import MyInspectorsComponent from '@/components/Pages/MyInspectors.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/inspectors',
  props: true,
  name: RouteNames.Inspectors,
  component: MyInspectorsComponent,
};

export default route;
